const Theme = {
  body_background_color: 'black',

  logo_image_url: 'manifdart.png',

  header_full_height: true,

  number_font: `'Montserrat', sans-serif`,

  title_font: `'Montserrat', sans-serif`,

  text_font: `'Montserrat', sans-serif`,

  button_color: '#ff5470ff',
  button_radius: 15,
  button_text_weight: 700,

  button_half_border_color: '#ff5470ff',

  footer_border_color: '#eee',
}

export default Theme
